module.exports = __webpack_public_path__ + "static/media/fb.be4b2f78.svg";